// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"single-module--wrapper--1UMh_","container":"single-module--container--1jRvL","headerWrap":"single-module--header-wrap--2tvvI","content":"single-module--content--3NcgR"};